<template>
  <div class="bcsf__filters-wrapper" v-if="filterGroups.length">
    <section class="bcsf__filters" style="z-index: 200">
      <button :class="bem('toggle--title')">
        {{ `${$language.collection.filter_by} - ${handle}` }}
      </button>
      <FilterGroup
        v-for="(filterGroup, idx) in filterGroups"
        :handle="handle"
        :activeBlock="activeBlock"
        :idx="idx"
        :filterGroup="filterGroup"
        :activeFilters="activeFilters"
        :swatches="swatches"
        @update="toggleFilterOption"
        :key="idx" />
      <button
        class="filter__group--clear-filters"
        v-if="!$isEmpty(activeFilters)"
        @click="clearFilters()"
        aria-label="Clear Filters">
        {{ $language.collection.clear_filters }}
      </button>
    </section>
  </div>
</template>

<script>
import useCollection from '../store/collection';
import FilterGroup from './FilterGroup';

export default {
  name: 'Filter',

  components: { FilterGroup },

  props: [
    'shop',
    'id',
    'handle',
    'productsPerPage',
    'page',
    'sort_order',
    'activeBlock',
  ],

  setup() {
    const { setLoading, setProducts, setFiltersActive } = useCollection();
    return { setLoading, setProducts, setFiltersActive };
  },

  data() {
    return {
      products: [],
      totalProducts: 0,
      filterGroups: [],
      activeFilters: {},
      activeSortBy: this.getSortByTitle(this.sort_order),
      activeSortByApi: this.sort_order,
      swatches: {},
    };
  },

  created() {
    this.filterDropdownOpen = this.$screen.tablet_m_up;

    fetch('/collections/all?view=swatches')
      .then((res) => res.json())
      .then((data) => {
        this.swatches = JSON.parse(data);
      });
  },

  mounted() {
    this.loadCollection();
  },

  watch: {
    products() {
      const filtered = Object.keys(this.activeFilters).length;
      
      if (filtered) {
        // globalThis.scrollTo(200, 1000);
      }
      
      this.setProducts(this.products, this.totalProducts, filtered);
    },

    page(newPage, oldPage) {
      if (newPage > oldPage) {
        this.getFilteredCollection(newPage);
      }
    },

    activeSortByApi() {
      this.getFilteredCollection(1, true);
      this.$emit('resetPage');
    },

    id() {
      this.getFilteredCollection(this.page);
    },
  },

  methods: {
    async loadCollection() {
      await this.getFilteredCollection(1);
    },

    toggleFilterOption(group, value) {
      if (!this.activeFilters[`${group.filterOptionId}--${value}`]) {
        this.activeFilters[`${group.filterOptionId}--${value}`] = group;
      } else {
        delete this.activeFilters[`${group.filterOptionId}--${value}`];
      }
      globalThis.scrollTo(200, 1000);
      this.getFilteredCollection(1, true);
      this.$emit('resetPage');
    },

    clearFilters() {
      this.activeFilters = {};
      this.getFilteredCollection(1, true);
      this.$emit('resetPage');
    },

    countActiveFilterOptions(groupId) {
      let count = 0;
      for (const key in this.activeFilters) {
        if (key.includes(groupId)) count++;
      }
      return count;
    },

    async getFilteredCollection(page = 1, reset = false) {
      // this.setLoading(true);
      if (reset) {
        this.products = [];
      }

      const url = new URL('https://services.mybcapps.com/bc-sf-filter/');
      const params = {
        shop: this.shop,
        country: globalThis.Shopify.country,
        currency: globalThis.Shopify.currency.active,
        currency_rate: globalThis.Shopify.currency.rate,
        return_all_currency_fields: false,
        page,
        limit: this.productsPerPage,
        product_available: false,
				variant_available: false,
        build_filter_tree: true,
        collection_scope: this.id,
      };


      url.pathname += 'filter';

      // Insert sort order
      params.sort = this.activeSortByApi;

      Object.keys(params).forEach((key) => {
        url.searchParams.append(key, params[key]);
      });

      // Insert filters
      if (this.activeFilters) {
        for (const [key, filter] of Object.entries(this.activeFilters)) {
          const filterValue = key.split('--')[1];
          if (filter.filterType === 'tag') {
            url.searchParams.append('tag[]', filterValue);
          } else {
            const filterKey = filter.filterOptionId;
            url.searchParams.append(`${filterKey}[]`, filterValue);
          }
        }
      }

      // Send request
      await fetch(url)
        .then((response) => response.json())
        .then((data) => {
          if (data.products.constructor !== Object) {
            this.products.push(...data.products);
            this.totalProducts = data.total_product;
            // Build filter tree
            this.filterGroups = data.filter.options.filter(
              (group) => group.values.length
            );
            this.$emit('updatePage', data.products.length);
          }
          // this.setLoading(false);
          this.setFiltersActive(!this.$isEmpty(this.activeFilters));
        })
        .catch((error) => {
          console.error('error', error);
        });
    },

    getSortByTitle(value) {
      return (
        this.$options.sortByOptions
          .filter((option) => option.api.includes(value))
          .pop().name || this.sort_order
      );
    },
  },

  sortByOptions: [
    {
      name: 'Alphabetically, A-Z',
      api: 'title-ascending',
    },
    {
      name: 'Alphabetically, Z-A',
      api: 'title-descending',
    },
    {
      name: 'Date, New to old',
      api: 'created-descending',
    },
    {
      name: 'Date, Old to new',
      api: 'created-ascending',
    },
    {
      name: 'Lowest Price',
      api: 'price-ascending',
    },
    {
      name: 'Highest Price',
      api: 'price-descending',
    },
    {
      name: 'Featured',
      api: 'manual',
    },
    {
      name: 'Relevance',
      api: 'relevance-descending',
    },
    {
      name: 'Best Selling',
      api: 'best-selling-descending',
    },
  ],
};
</script>
